import type { TenantConfig } from "./types";

// bosong — sibling school tenant. Logo + favicon proxy through to the
// existing bosong.os.meganovaai.com nova-os deployment (see the
// /brand/ + /favicon.ico locations in the .52 nginx vhost), so both
// apps share the same Bosong school assets without duplicating.
export const bosongTenant: TenantConfig = {
  slug: "bosong",
  displayName: "南京博颂学校",
  tagline: "学校 AI 平台",
  defaultLocale: "zh-CN",
  subjects: [
    { agentId: "chemistry-assistant", labelKey: "chat.subjects.chemistry" },
    { agentId: "math-assistant", labelKey: "chat.subjects.math" },
    { agentId: "english-assistant", labelKey: "chat.subjects.english" },
  ],
  brand: {
    logoSrc: "/brand/nova_os_icon_256.svg",
  },
  // "i-Target" 是博颂 i⁵ 教学法的专有名词,只在 bosong 租户展示;
  // 通用默认文案是"课前诊断"(Jarod 2026-08-18)。
  stringOverrides: {
    "zh-CN": {
      "itarget.title": "i-Target 课前诊断",
    },
    en: {
      "nav.itarget": "i-Target",
      "itarget.title": "i-Target Pre-class Diagnostic",
      "subjects.modules.itarget": "iTarget",
    },
  },
};
